import upperFirst from 'lodash/upperFirst'
import get from 'lodash/get'

const parseParams = ({ params = {}, options = {} } = {}) => {
  return {
    value: get(params, 'value') || get(params, 'param') || ''
  }
}

export default (args) => {
  const { value } = parseParams(args)
  return upperFirst(value)
}

const humanizeCall = (args) => {
  return 'Uppercase first letter'
}

export {
  humanizeCall
}
